export default "__VITE_ASSET__42216f61__"